import { createFeatureSelector } from '@ngrx/store';
import {
  BulkAddNewState,
  BulkHistoryState,
  ErrorLogsState,
  NewBulkOperationState,
  SearchBulkState,
  SideNavState,
} from '../models/bulk.models';
import { BulkAddNewReducer } from './bulk-add-new.reducer';
import { BulkHistoryReducer } from './bulk-history.reducer';
import { ErrorLogsReducer } from './error-logs.reducer';
import { NewBulkOperationReducer } from './new-bulk-operations.reducer';
import { SearchBulkReducer } from './search-bulk.reducer';
import { SideNavReducer } from './side-nav.reducer';

export const featureBulkOperationsName = 'BulkOperations';

export interface DragonflyState {
  searchBulk: SearchBulkState;
  sideNav: SideNavState;
  bulkHistory: BulkHistoryState;
  errorLogs: ErrorLogsState;
  addNewConf: BulkAddNewState;
  newOperation: NewBulkOperationState;
}

export const moduleBulkOperationsReducers = {
  searchBulk: SearchBulkReducer,
  sideNav: SideNavReducer,
  bulkHistory: BulkHistoryReducer,
  errorLogs: ErrorLogsReducer,
  addNewConf: BulkAddNewReducer,
  newOperation: NewBulkOperationReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(
  featureBulkOperationsName
);
